import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 bg-primary-500 rounded-lg flex items-center justify-center">
                <i className="ri-quill-pen-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
                一起草
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              一起草是专为团队打造的多人协同文稿创作工具，让每一次文稿协作都高效顺畅。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">产品</h4>
            <ul className="space-y-2.5">
              <li>
                <a href="#features" className="text-sm text-background-400 hover:text-background-100 transition-colors">功能介绍</a>
              </li>
              <li>
                <a href="#categories" className="text-sm text-background-400 hover:text-background-100 transition-colors">应用场景</a>
              </li>
              <li>
                <a href="#pricing" className="text-sm text-background-400 hover:text-background-100 transition-colors">定价方案</a>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors">更新日志</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">分类导航</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-100 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line text-base"></i>
                <span>support@utshealth.cn</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-9999</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line text-base"></i>
                <span>北京市海淀区中关村科技园</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2024 - 2026 一起草 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors" rel="nofollow">Cookie政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}